document.addEventListener('DOMContentLoaded', async ()=>{

  const weight =
    document.getElementById('asia24-product-weight');

  const fill =
    document.getElementById('asia24-product-fill');

  const missing =
    document.getElementById('asia24-product-missing');

  if(!weight) return;

  const cart =
    await fetch('/cart.js')
    .then(r=>r.json());

  let totalWeight = 0;

  cart.items.forEach(item=>{

    totalWeight +=
      item.grams * item.quantity;

  });

  const left =
    Math.max(0,1000-totalWeight);

  weight.textContent =
    `${totalWeight}g / 1000g`;

  fill.style.width =
    Math.min(
      (totalWeight/1000)*100,
      100
    ) + '%';

  if(left > 0){

    missing.textContent =
      `${left}g more needed`;

  }else{

    missing.textContent =
      '🎉 Package Ready';

  }

});